const normalizedErrorTypeLabel = new Map<string, string>();
normalizedErrorTypeLabel.set('constrain_violation', 'Item is still linked with another');
normalizedErrorTypeLabel.set('router_config_missing', 'Router config is missing');
normalizedErrorTypeLabel.set('invalid_state', 'Invalid State');
normalizedErrorTypeLabel.set('cloning_failed', 'Cloning failed!');

export const webapiErrorToLabel = normalizedErrorTypeLabel;



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/common/ngx-http-loader/loader-service/config/webapi-response-errors.ts